class BaseResponse {
  constructor(success, body) {
    this.success = success;
    this.body = body;
  }
}

class FailureResponse extends BaseResponse {
  constructor(errorCode, body) {
    super(false, body);
    this.errorCode = errorCode;
  }
}

class SuccessResponse extends BaseResponse {
  constructor(body) {
    super(true, body);
  }
}

module.exports = { SuccessResponse, FailureResponse };
